export default "__VITE_ASSET__BiS4D8MH__"